import { gql } from '@apollo/client';

export default gql`
  mutation processVoucherPrrRefund(
    $amount: Float!
    $currency: Currency!
    $validUntil: String!
    $firstName: String!
    $lastName: String!
    $recipientEmail: String!
    $associatedPNR: String!
    $language: Language
    $additionalDetails: [InputAdditionalDetails!]!
    $type: String
    $compensationRecordsToUpdate: [InputCompensationRecordToUpdate]
  ) {
    processVoucherPrrRefund(
      amount: $amount
      currency: $currency
      validUntil: $validUntil
      firstName: $firstName
      lastName: $lastName
      recipientEmail: $recipientEmail
      associatedPNR: $associatedPNR
      language: $language
      additionalDetails: $additionalDetails
      type: $type
      compensationRecordsToUpdate: $compensationRecordsToUpdate
    ) {
      bookingReference
      voucher {
        alias
      }
      updatedCompensationRecords
    }
  }
`;
